import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CustomerDashboardState, ICustomerDashboardStats } from "../../../types/dashboard/customerDashboardInterfaces";

const initialState: CustomerDashboardState = {
  stats: {
    totalCustomers: 0,
    activeCustomers: 0,
    inactiveCustomers: 0,
    customersByTaxpayerCategory: {},
    customersByEntityType: {},
  },
};

export const customerDashboardSlice = createSlice({
  name: "customerDashboard",
  initialState,
  reducers: {
    /**
     * Carga las estadísticas correctamente.
     */
    setStats: (state, action: PayloadAction<ICustomerDashboardStats>) => {
      state.stats = action.payload;
    },

    /**
     * Permite limpiar el estado si se requiere.
     */
    clearStats: (state) => {
      state.stats = {
        totalCustomers: 0,
        activeCustomers: 0,
        inactiveCustomers: 0,
        customersByTaxpayerCategory: {},
        customersByEntityType: {},
      };
    },
  },
});

export const { setStats, clearStats } = customerDashboardSlice.actions;
export default customerDashboardSlice.reducer;
